// extracted by mini-css-extract-plugin
export default {"cell-icon-block":"components-hotel-pricing-assistant-table-cells-td-own-rate-dynamic-rate-pricing-cell-value-module__cell-icon-block"};